module.exports = __webpack_public_path__ + "static/img/nine5.279939a0.jpg";